import PartnerBanks from "@/components/landing/PartnerBanks";
import { useCallback } from "react";
import SEO from "@/components/common/SEO";
import { LOAN_TYPES } from "@/constants/loanTypes";

import LoanLayout from "@/components/loans/LoanLayout";
import LoanHero from "@/components/loans/LoanHero";
import LoanOverview from "@/components/loans/LoanOverview";
import LoanBenefits from "@/components/loans/LoanBenefits";
import LoanTypes from "@/components/loans/LoanTypes";
import LoanEligibility from "@/components/loans/LoanEligibility";
import LoanDocuments from "@/components/loans/LoanDocuments";
import LoanProcess from "@/components/loans/LoanProcess";
import WhyMoneyMart from "@/components/loans/WhyMoneyMart";
import LoanFAQ from "@/components/loans/LoanFAQ";
import LoanCTA from "@/components/loans/LoanCTA";
import LeadFormSection from "@/components/loans/LeadFormSection";

import { lrdProgram } from "@/data/loans";

const LRDProgram = () => {
  const scrollToLeadForm = useCallback(() => {
    const el = document.getElementById("lead-form");

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);

  return (
    <>
      <SEO {...lrdProgram.seo} />
      <LoanLayout onCtaClick={scrollToLeadForm}>
        <LoanHero
          {...lrdProgram.hero}
          onPrimaryClick={scrollToLeadForm}
          onSecondaryClick={scrollToLeadForm}
        />

        <LoanOverview {...lrdProgram.overview} />

        <LoanBenefits {...lrdProgram.benefits} />

        <LoanTypes {...lrdProgram.types} />

        <LoanEligibility
          {...lrdProgram.eligibility}
          onCheckEligibility={scrollToLeadForm}
        />

        <LoanDocuments {...lrdProgram.documents} />

        <LoanProcess {...lrdProgram.process} />

        <WhyMoneyMart {...lrdProgram.whyMoneyMart} />

        <PartnerBanks />

        <LoanFAQ {...lrdProgram.faq} />

        <LoanCTA {...lrdProgram.cta} onApply={scrollToLeadForm} />

        <LeadFormSection
          {...lrdProgram.leadForm}
          loanType="LRD_PROGRAM"
        />
      </LoanLayout>
    </>
  );
};

export default LRDProgram;
